import { useMemo } from 'react';

import useVideosListingStore from 'layout/Listing/variants/videos/store';

import { toKebabCase } from 'utils/strings';

const checkFilters = (video: { data: VideoResource }, filter: string) => {
  const tags = video.data?.tags?.map(tag => toKebabCase(tag || '')) || [];

  return filter === 'All' || tags.includes(toKebabCase(filter));
};

const useFilterVideos = (allVideos: { data: VideoResource }[]) => {
  const activeFilter = useVideosListingStore(state => state.filters);
  const search = useVideosListingStore(state => state.search);

  return useMemo(() => {
    if (!activeFilter && !search) {
      return allVideos;
    }

    const filtered = allVideos.filter(video => checkFilters(video, activeFilter));

    return filtered.filter(video => video?.data?.title?.toLowerCase().includes(search.toLowerCase()));
  }, [allVideos, activeFilter, search]);
};

export default useFilterVideos;
